import React from 'react'
import { clearToken } from '../../../modules/auth/auth'
import AppNavbarButton from './AppNavBarButton'

function handleLogout(e) {
  clearToken()
  window.location.reload()
}

export default () => (
  <div className="navbar-item">
    <div className="field is-grouped">
      <AppNavbarButton to="/moment/create">
        <i className="far fa-edit" />
      </AppNavbarButton>

      <AppNavbarButton to="/#">
        <ion-icon name="person" />
      </AppNavbarButton>

      <AppNavbarButton onClick={handleLogout}>
        <ion-icon name="log-out" />
      </AppNavbarButton>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/templates/app/AppNavBarButtonGroup.js